module.exports = __webpack_public_path__ + "assets/img/8df17430fe43d427790f95f4d370dcb3.webp";